const vars = {
	VERSION: "0.12.0",
	NAME: "@sage-js/res-osi-asm"
};

export const {NAME, VERSION} = vars;
